import { useContext, useEffect, useState } from "react";
import AppContext from "../../context";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const Navigation = () => {
  const [zoom, setZoom] = useState("50");
  const [rotate, setRotate] = useState("50");
  const [pan, setPan] = useState("50");
  const [tilt, setTilt] = useState("50");
  const [explode, setExplode] = useState("0");
  const { handleSetDisableAllTools } = useContext(AppContext);
  useEffect(() => {
    if (parseFloat(explode) > 0) handleSetDisableAllTools(true);
    else handleSetDisableAllTools(false);
  }, [explode]);

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  return (
    <>
      <div className="navigation" id="navigation">
        <p
          className="navigation--title title is-size-6 mb-4"
          style={labelStyle}
        >
          3D Navigation
        </p>
        <div className="mt-2 mb-2 is-flex is-justify-content-space-between">
          <button
            className="button is-primary is-outlined is-fullwidth mr-2"
            style={labelStyle}
            id="topView"
          >
            Top View
          </button>
          <button
            className="button is-primary is-fullwidth is-outlined ml-2"
            style={labelStyle}
            id="resetView"
          >
            3D View
          </button>
        </div>
        <label>
          <div className="three-d-input-label">
            <strong style={labelStyle}>Zoom</strong>
            <small style={labelStyle}>Mouse wheel</small>
          </div>
          <input
            className="slider is-fullwidth is-large is-circle"
            id="zoomRange"
            step="1"
            min="0"
            max="100"
            value={zoom}
            type="range"
            onChange={(event) => setZoom(event.target.value)}
          />
        </label>
        <label>
          <div className="three-d-input-label">
            <strong style={labelStyle}>Rotate</strong>
            <small style={labelStyle}>Left click + drag left or right</small>
          </div>
          <input
            className="slider is-fullwidth is-large is-circle"
            id="rotateRange"
            step="1"
            min="0"
            max="100"
            value={rotate}
            type="range"
            onChange={(event) => setRotate(event.target.value)}
          />
        </label>
        <label>
          <div className="three-d-input-label">
            <strong style={labelStyle}>Pan</strong>
            <small style={labelStyle}>Right click + drag</small>
          </div>
          <input
            className="slider is-fullwidth is-large is-circle"
            id="panRange"
            step="1"
            min="0"
            max="100"
            value={pan}
            type="range"
            onChange={(event) => setPan(event.target.value)}
          />
        </label>
        <label>
          <div className="three-d-input-label">
            <strong style={labelStyle}>Tilt</strong>
            <small style={labelStyle}>Left click + drag up or down</small>
          </div>
          <input
            className="slider is-fullwidth is-large is-circle"
            id="tiltRange"
            step="1"
            min="0"
            max="100"
            value={tilt}
            type="range"
            onChange={(event) => setTilt(event.target.value)}
          />
        </label>
        <label>
          <div className="three-d-input-label">
            <strong style={labelStyle}>Explode</strong>
          </div>
          <input
            className="slider is-fullwidth is-large is-circle"
            id="explodeRange"
            min="0"
            max="5"
            step="0.5"
            value={explode}
            type="range"
            onChange={(event) => setExplode(event.target.value)}
          />
        </label>
      </div>
      <hr className="horizontal"></hr>
    </>
  );
};

export default Navigation;
